// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editGalleryModal__tY_b4 {
  width: 890px;
  height: 750px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .editGalleryModal__tY_b4 {
    width: 750px;
    height: 680px;
  }
}
@media (max-width: 800px) {
  .editGalleryModal__tY_b4 {
    width: 675px;
    height: 584px;
  }
}

.modalBody__W4w_A {
  height: 100%;
  padding: 0 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
@media (max-width: 800px) {
  .modalBody__W4w_A {
    padding: 10px 15px 5px;
    gap: 10px;
  }
}

.galleryButton__Fr8Tu {
  width: 100px;
}

.errorMessage__WnXM4 {
  height: 15px;
  margin-left: 25px;
}
.errorMessage__WnXM4 span {
  display: block;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 15px;
}

.modalFooter__spsIw {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 25px 25px;
  gap: 20px;
}
@media (max-width: 800px) {
  .modalFooter__spsIw {
    padding: 11px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditSensorGalleryModal/components/DropzoneStep/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAzEF;AA2EE;EANF;IAOI,YAAA;IACA,aAAA;EAxEF;AACF;AA0EE;EAXF;IAYI,YAAA;IACA,aAAA;EAvEF;AACF;;AA0EA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvEF;AAyEE;EARF;IASI,sBAAA;IACA,SAAA;EAtEF;AACF;;AAyEA;EACE,YAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,iBAAA;AAtEF;AAwEE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAtEJ;;AA0EA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAvEF;AAyEE;EARF;IASI,kBAAA;EAtEF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editGalleryModal {\n  width: 890px;\n  height: 750px;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    width: 750px;\n    height: 680px;\n  }\n\n  @media (max-width: 800px) {\n    width: 675px;\n    height: 584px;\n  }\n}\n\n.modalBody {\n  height: 100%;\n  padding: 0 5px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n\n  @media (max-width: 800px) {\n    padding: 10px 15px 5px;\n    gap: 10px;\n  }\n}\n\n.galleryButton {\n  width: 100px;\n}\n\n.errorMessage {\n  height: 15px;\n  margin-left: 25px;\n\n  span {\n    display: block;\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-top: 4px;\n    min-height: 15px;\n  }\n}\n\n.modalFooter {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 10px 25px 25px;\n  gap: 20px;\n\n  @media (max-width: 800px) {\n    padding: 11px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editGalleryModal": `editGalleryModal__tY_b4`,
	"modalBody": `modalBody__W4w_A`,
	"galleryButton": `galleryButton__Fr8Tu`,
	"errorMessage": `errorMessage__WnXM4`,
	"modalFooter": `modalFooter__spsIw`
};
module.exports = ___CSS_LOADER_EXPORT___;
